import * as React from "react";
const SvgFiRrCandyBar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-candy-bar_svg__a)">
      <path
        fill="#062147"
        d="M21.84 5.653a1.003 1.003 0 0 0 .266-1.605l-2.489-2.489a5.3 5.3 0 0 0-3.766-1.56 5.3 5.3 0 0 0-3.766 1.56L2.56 11.085A5.3 5.3 0 0 0 1 14.851a5.3 5.3 0 0 0 1.56 3.766l3.824 3.823A5.3 5.3 0 0 0 10.15 24a5.3 5.3 0 0 0 3.766-1.56l8.059-8.059a.998.998 0 0 0-.212-1.576 1.5 1.5 0 0 1-.762-1.305c0-.427.184-.835.501-1.119.327-.291.514-.703.514-1.131s-.187-.84-.513-1.13A1.5 1.5 0 0 1 21.001 7c0-.576.32-1.092.839-1.347M16.066 17.46l-3.591-3.591 3.273-3.273 3.576 3.576.015.014zM10.812 5.661l3.522 3.522-3.273 3.273-3.522-3.522 3.272-3.272zm9.007 3.589a3.5 3.5 0 0 0-.79 1.8l-1.867-1.867 1.854-1.854a3.5 3.5 0 0 0 .803 1.921M15.85 2c.889 0 1.724.346 2.352.974l1.17 1.17-3.625 3.624-3.522-3.522 1.273-1.273A3.3 3.3 0 0 1 15.85 2M12.5 21.026c-1.256 1.257-3.447 1.257-4.703 0l-3.824-3.823a3.3 3.3 0 0 1-.974-2.352c0-.889.346-1.724.974-2.352l2.151-2.151 8.527 8.527z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-candy-bar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCandyBar;
